import { Component, ViewChild } from '@angular/core';
import { ColumnBase } from '@progress/kendo-angular-excel-export';
import { DataBindingDirective, DomEventsService, GridComponent, PageChangeEvent, SelectableSettings, SelectionEvent } from '@progress/kendo-angular-grid';
import { TooltipDirective } from "@progress/kendo-angular-tooltip";
import { CompositeFilterDescriptor, GroupDescriptor, SortDescriptor, State } from "@progress/kendo-data-query";
import { saveAs } from "file-saver";
import { EmdmIcons } from 'src/app/services/appicons.service';
import { commonService } from 'src/app/services/common.service';
import { userManagerService } from 'src/app/services/userManager.service';
@Component({
  selector: 'app-user-manager',
  templateUrl: './user-manager.component.html',
  styleUrl: './user-manager.component.scss',
})
export class UserManagerComponent {
  faCompleted = this.emdmicon.FacircleCheck;
  faError = this.emdmicon.FaTimesClock;
  faFilter = this.emdmicon.faFilter;
  faSort = this.emdmicon.FaSort;
  faSave = this.emdmicon.FaSave;
  facircle = this.emdmicon.FacircleCheck;
  faStop = this.emdmicon.facircleHollow;
  selectedValue = { text: 'Set Default Group', value: 'DEFAULT' };
  dropDownList = new Array<any>;
  statusSelected: string = ""

  public selectableSettings!: SelectableSettings;
  public selectedIds: Set<number> = new Set<number>();
  public selectedIndexes: number[] = [];
  searchString: string = "";
  sort: SortDescriptor[] = [];
  defaultFilter: CompositeFilterDescriptor = {
    logic: 'and',
    filters: []
  };

  filter: CompositeFilterDescriptor = {
    logic: 'and',
    filters: []
  };
  group: GroupDescriptor[] = [];
  public statusCount = {
    Completed: 0,
    InError: 0
  }

  saveConfigs = {
    sortConfig: [],
    filterConfig: [],
    groupConfig: []
  }

  gridConfig: any = null;
  skip = 0;
  public selectList = []
  UserManagerView: any = [];
  UserManagerData: any = [];
  dropDownData: any = [];
  @ViewChild(DataBindingDirective)
  dataBinding!: DataBindingDirective;
  @ViewChild('tooltipDir', { static: true }) public tooltipDir!: TooltipDirective;
  @ViewChild(GridComponent) userManagerGrid!: GridComponent;

  excelFileCustomName = ""
  constructor(private emdmicon: EmdmIcons, private commonService: commonService, private userManagerService: userManagerService) {
    this.setSelectableSettings();
  }

  ngOnInit() {
    this.getGridConfig();
    this.getDefaultFilters();
  }

  setDefaultConfig(){
    this.filter = this.defaultFilter;
    this.sort = [];
    this.group = [];

    this.userManagerGrid.filter = this.filter;
    this.userManagerGrid.sort = this.sort;
    this.userManagerGrid.group = this.group;

    this.userManagerGrid.skip = 0;
    this.skip = 0;

    this.gridConfig = {
      columnInfo: [],
      filter: this.filter,
      sort: this.sort,
      group: this.group
    };

    this.selectedIds = new Set<number>();
    this.selectedIndexes = [];
  }

  getUserData() {
    this.userManagerService.getUserManagerData(this.searchString).subscribe((data) => {
      this.UserManagerData = JSON.parse(JSON.stringify(data));
      this.UserManagerView = JSON.parse(JSON.stringify(data));
      this.setActive();
      this.commonService.showNotificationMessage(data.length + " User Record(s) were successfully loaded.","success","center")
      if (this.userManagerGrid && this.gridConfig != null) {
        this.userManagerGrid.columnList.forEach((x: any) => {
          let colIndex = this.gridConfig.columnInfo?.findIndex((y: any) => (x.field ?? "") == y.field);
          if (colIndex > -1) {
            x.width = this.gridConfig.columnInfo[colIndex].width;
            x.orderIndex = this.gridConfig.columnInfo[colIndex].orderIndex;
          }
        });

        this.filter = this.gridConfig?.filter ?? this.filter;
        this.userManagerGrid.filter = this.filter;
        this.group = this.gridConfig?.group ?? this.group;
        this.userManagerGrid.group = this.group;
        this.sort = this.gridConfig?.sort ?? this.sort;
      }
    });
  }

  pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
  }

  getGridConfig() {
    this.userManagerService.getConfig().subscribe({
      next: (data: any) => {
        if (data) {
          this.gridConfig = data;
          this.getUserData();
        }
      },
      error: () => {
        this.getUserData();
      }
    })
  }

  getDefaultFilters() {
    this.userManagerService.getDefaultList().subscribe((data) => {
      this.dropDownData = JSON.parse(JSON.stringify(data));
      data.map((newData: any) => {
        this.dropDownList.push({ text: newData.display, value: newData.groupChangeOptionName });
      })
    })
  }

  searchUser() {
    this.setDefaultConfig();
    this.getUserData();
  }

  setActive() {
    this.statusCount.Completed = this.UserManagerView.filter((x :any)=>x.isActive)?.length;
    this.statusCount.InError = this.UserManagerView.length - this.statusCount.Completed;
    // this.UserManagerView.map((data: any) => {
    //   if (data.isActive) {
    //     this.statusCount.Completed++;
    //   } else {
    //     this.statusCount.InError++;
    //   }
    // })
  }

  OnSortChange(event: SortDescriptor[]): void {
    this.sort = event;
    this.skip = 0;
  }

  clearSort() {
    this.sort = [];
  }

  OnFilterChange(event: CompositeFilterDescriptor): void {
    this.filter = event;
  }

  groupChange(event: any) {
    this.group = event;
    this.skip = 0;
  }

  clearFilter() {
    this.filter = {
      logic: 'and',
      filters: []
    }

    this.userManagerGrid.filter = this.filter;
  }

  sortChange(event: any) {
    this.sort = event;
    this.userManagerGrid.sort = this.sort;
  }

  OnKeyDown(event: any) {
    if (event.key === 'Enter') {
      this.getUserData();
    }
  }

  assignGroups() {
    let payload = {
      groupChangeOptionName: this.selectedValue.value,
      userIds: Array.from(this.selectedIds)
    };

    this.userManagerService.changeRoleOfUser(payload).subscribe({
      next: (data: any) => {
        this.commonService.showNotificationMessage("The "+ this.selectedIds.size+" selected User Record(s) was updated; Press SEARCH Button to Refresh Grid.","success","center")        
      }
    });
  }

  public setSelectableSettings(): void {

    this.selectableSettings = {
      cell: true,
      mode: "single",
      drag: false,
      // checkboxOnly: true
    };
  }

  public OnSelectionChangeEvent(event: SelectionEvent): void {
    this.selectedIds = this.commonService.onGridSelection(this.selectedIds, event, 'id');
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    if (element.nodeName === "TD" && element.innerText.trim()) {
      this.tooltipDir.toggle(element);
    } else {
      this.tooltipDir.hide();
    }
  }

  exportUserList() {
    this.userManagerService.downloadUserlistExcel().subscribe((data) => {
      saveAs(data, 'EMDM_Users_Export.xlsx');
      this.commonService.showNotificationMessage(
        'file downloaded successfully',
        'success',
        'center'
      );
    });
  }

  clearConfig(grid: GridComponent) {
    let isConfirmed = confirm("Are you sure you want to reset the configurations?");
    if (isConfirmed) {

      this.setDefaultConfig();

      this.userManagerService.saveConfig(this.gridConfig).subscribe({
        next: () => {
          this.commonService.showNotificationMessage('Configurations reset successfully.', "success", "center");
          this.getUserData();
        }
      });
    }
  }

  saveConfig(grid: GridComponent) {
    let isConfirmed = confirm("Are you sure you want to save the configurations?");
    if (isConfirmed) {
      let columnList: any[] = [];
      grid.columnList.rootColumns().forEach((x: any) => {
        let data = {
          field: x.field ?? "",
          width: x.width,
          orderIndex: x.orderIndex
        };
        columnList.push(data);
      });

      this.gridConfig = {
        columnInfo: columnList,
        filter: this.filter,
        sort: this.sort,
        group: this.group
      };

      this.userManagerService.saveConfig(this.gridConfig).subscribe((x: any) => {
        this.commonService.showNotificationMessage('Configurations saved successfully.', "success", "center");
      });
    }
  }

}

